module.exports = __webpack_public_path__ + "assets/img/logo-paynow-creditcard.2220ac3e.png";